<template>
    <div>
        <div class="title">
            <el-breadcrumb >
                <el-breadcrumb-item>优客码</el-breadcrumb-item>
                <el-breadcrumb-item>订单管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="main">
          <el-card>

       
        <!--搜索  -->
        <el-row :gutter="10" class="index-head">
            <el-col :span="4">
                <el-input placeholder="搜索商品名" v-model="goodsname" clearable> </el-input>
            </el-col>
            <!--  <el-col :span="4">
        <el-select v-model="potValue"
                   placeholder="请选择经济人">
          <el-option v-for="item in GLOBALState.erw_options"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
      </el-col> -->

            <el-col :span="4">
                <el-select v-model="statusValue" placeholder="请选择活动">
                    <el-option v-for="item in GLOBALState.erw_options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
            </el-col>
            <el-col :span="8">
                <el-date-picker v-model="timeinterval" type="daterange" clearable value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期" />
            </el-col>
            <el-col :span="8">
                <el-button type="primary" @click="handleButton(1)"> 搜 索 </el-button>
                <el-button @click="handleButton(2)"> 重 置 </el-button>
            </el-col>
        </el-row>
        <!-- table -->
        <div class="table-content">
            <el-table :data="list" border v-loading="listLoading">
                <el-table-column label="订单号" prop="orders_sn"></el-table-column>
                <el-table-column label="商品名称" prop="goods_names"></el-table-column>
                <el-table-column label="参与活动名称" prop="rebate_name"></el-table-column>
                <el-table-column label="交易金额" prop="goods_payments_amounts"></el-table-column>
                <el-table-column label="数量" prop="goods_number"></el-table-column>
                <el-table-column label="分润比例" prop="proportion"></el-table-column>
                <el-table-column label="分润金额" prop="proportion_price"></el-table-column>
                <el-table-column label="经济人" prop="agent_name"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" @click="handleButton(3, scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页 -->
        <pagination v-if="list.length > 0" :total="total" :pageNum="pageNum" :pageSize="pageSize" @pageChange="pageChange" />
        <!-- 详情 -->
        <div v-if="goodsVisible">
            <orderView :details_list="details_list" @closeModel="initModel(1)"></orderView>
        </div>
           </el-card>
        </div>
    </div>
</template>

<script>
import orderView from "./common/orderView.vue";
import { getshoplist, orderList } from "@/api/erweima/index";
import pagination from "@/components/pagination/index.vue";

export default {
    props: {},
    data() {
        return {
            goodsname: "",
            potValue: "",
            statusValue: "",
            timeinterval: "",
            list: [],
            pageSize: 5,
            pageNum: 0,
            total: 0,
            listLoading: false,
            goodsVisible: false,
            details_list: {},
        };
    },
    mounted() {
        this.getorderList();
    },
    methods: {
        initModel(num) {
            if (num == 1) {
                this.goodsVisible = false;
            }
        },
        pageChange(page) {
            this.pageSize = page._pageSize;
            this.pageNum = page._currentPage;
            this.getorderList();
        },
        handleButton(key, details_list) {
            switch (key) {
                case 1:
                    this.pageNum = 0;
                    this.getorderList();
                    break;
                case 2:
                    this.goodsname = "";
                    this.statusValue = "";
                    this.timeinterval = "";
                    this.pageNum = 0;
                    this.getorderList();
                    break;
                case 3:
                    this.goodsVisible = true;
                    this.details_list = details_list;
                    break;
                default:
                    break;
            }
        },
        getshoplist_() {
            let par = {
                token: this.$getSessionStorage("token"),
            };
            getshoplist(par)
                .then((res) => {
                    if (res.code == 1) {
                        this.mailOptionsCopy = res.data.list;
                    } else {
                        this.$message.error({ message: res.msg });
                    }
                })
                .catch((err) => {});
        },
        //列表
        getorderList() {
            this.listLoading = true;
            let par = {
                token: this.$getSessionStorage("token"),
                goods_name: this.goodsname,
                rebate_id: this.statusValue,
                agent_id: this.potValue,
                offset: this.pageNum,
                limit: this.pageSize,
            };
            orderList(par)
                .then((res) => {
                    this.listLoading = false;
                    if (res.code == 1) {
                        this.list = res.data.list;
                        this.total = parseInt(res.data.count);
                    } else {
                        this.$message.error({ message: res.msg });
                    }
                })
                .catch((err) => {});
        },
    },
    components: {
        pagination,
        orderView,
    },
};
</script>

<style scoped lang="scss">
.index-head {
    width: 100%;
    padding: 16px 0px;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 0.7);
}
 .title {
        box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
        width: 100%;
        background: #fff;
        font-size: 20px;
        color: #000000;
        width: 100%;
        padding: 15px 32px;
    }
.main {
        min-width: 1200px;
        margin: 20px;
           .el-card {
        min-height: 780px;
    }
}
</style>
